import { createSelector } from 'reselect';

const getHttpError = (
  state: import('../types/rootState').RootState
): import('../types/commontypes').HttpError => state.httpError || {};

const getHttpErrorError = createSelector(getHttpError, ({ error }) => error || {});
const getErrorMessage = createSelector(getHttpErrorError, ({ message }) => message);

const errorInHomePage = (state: import('../types/rootState').RootState): boolean =>
  ['504', '503'].includes(state?.httpError?.home?.errorCode);

const captchaRequiredErrorInAuth = createSelector(
  getHttpErrorError,
  errorObj => errorObj?.subject === 'captchaInputRequired'
);

const redirectToOTPInAuth = createSelector(getHttpErrorError, errorObj =>
  Boolean(errorObj?.redirectToOTP)
);

const errorCodePdp = (state: import('../types/rootState').RootState): string =>
  state?.httpError?.pdp?.errorCode;

export {
  getHttpError,
  getHttpErrorError,
  getErrorMessage,
  errorInHomePage,
  errorCodePdp,
  captchaRequiredErrorInAuth,
  redirectToOTPInAuth
};
